import React from 'react';
import { PhoneIcon } from 'lucide-react';
import { SITE } from '../lib/site';

// Fixed mobile call bar — keeps the phone-first opt-in one tap away on small screens.
export function CallBar() {
  return <a href={SITE.phoneHref} className="fixed inset-x-0 bottom-0 z-50 flex items-center justify-center gap-2 bg-jk-red px-4 py-3.5 font-display text-xl font-bold uppercase tracking-wide text-white shadow-[0_-6px_20px_rgba(0,0,0,0.4)] sm:hidden" data-id="element-16" data-mp="171op4tyg1ig4">
      <PhoneIcon className="h-5 w-5" data-id="element-17" data-mp="jcdkh1dz33wp" />
      Call {SITE.phoneDisplay}
    </a>;
}